import { css } from '@emotion/core';
import * as commonStyles from '../common.style';
export var horizontalSlide = {
  name: "c7ak1b",
  styles: "margin:0;display:flex;justify-content:space-between;"
};
export var scroll = {
  name: "bg7p2q",
  styles: "justify-content:flex-start;gap:30px;overflow-x:auto;padding-right:14px;"
};
export var title = commonStyles.mainTitle;